import {Head, router, useForm} from '@inertiajs/react'
import Layout from "../../components/layout";
import {ArrowRightIcon} from '@heroicons/react/24/solid/index.js';
import {useCallback} from 'react';
import colors from '../../colors.js';
import toast from 'react-hot-toast';
import {GoogleLogin} from '@react-oauth/google';

export default function Login({storeUrl, checkUrl}) {

    const {data, setData, post, processing, errors} = useForm({
        email: '',
    })

    const onLoggingIn = useCallback(async (tokenResponse) => {
        try {
            const response = await axios.post(storeUrl, {
                access_token: tokenResponse.credential,
            });

            if (response.data.url){
                router.get(response.data.url);
            }

        } catch (err) {
            if (err.response && err.response.status === 400 && err.response.data.message) {
                toast.error(err.response.data.message);
                return;
            }

            if (err.response && err.response.status === 419) {
                window.location.reload();
            }

            throw err;
        }

    }, [])


    const onTokenResponse = async (tokenResponse) => {
        await toast.promise(onLoggingIn(tokenResponse), {
            loading: 'Logging in...',
            success: 'Successfully logged in!',
            error: 'Error while logging in',
        })
    };

    const checkEmail = useCallback(() => {
        post(checkUrl);
    }, [checkUrl, data.email]);

    return (<Layout>
        <Head title={"Log in"} />
        <div className="relative h-full">
            <div
                className="flex full-screen h-full flex-col flex-grow bg-gradient-to-b from-transparent via-transparent to-black px-[20px] pb-[20px]">
                <div className="flex flex-grow flex-col items-center justify-center">
                    <div className="w-full">

                        <div>
                            <label className="text-white font-bold" htmlFor="email">What's your email?</label>
                            <input
                                id="email"
                                placeholder={'email@example.com'}
                                className="w-full border-2 py-4 px-6 rounded-[20px] text-white"
                                style={{
                                    backgroundColor: colors.backdropBackground,
                                    borderColor: colors.borderBottomColor,
                                }}
                                type="email"
                                value={data.email}
                                onChange={e => setData('email', e.target.value)}
                            />
                            <div>
                                {errors.email && <small className="text-red-500">{errors.email}</small>}
                            </div>
                            <small className="text-white">So we can send you an email when the album
                                reveals.</small>
                        </div>
                        <button
                            className="flex-wrap w-full shadow transition duration-300 transform px-6 py-3 font-medium text-white mt-[10px] rounded-[10px] focus:outline-none hover:shadow-md bg-primary-500 hover:bg-primary-500/80 focus:bg-primary-500/80 text-center flex flex-row items-center justify-center"
                            type="button"
                            disabled={processing}
                            onClick={checkEmail}>
                            Continue <ArrowRightIcon className="w-4 h-4 text-white ml-2" />
                        </button>
                    </div>
                </div>
                <GoogleLogin
                    use_fedcm_for_prompt={true}
                    text="continue_with"
                    width={window.innerWidth - 40}
                    onSuccess={onTokenResponse}
                    useOneTap={true} />
            </div>
        </div>
    </Layout>)
}
